var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "14px" } },
    [
      _c("div", { staticClass: "div-screen" }, [
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("客户名称：")]),
            _c(
              "el-select",
              {
                staticClass: "mr-24",
                staticStyle: { width: "300px" },
                attrs: {
                  placeholder: "请选择客户名称",
                  size: "small",
                  filterable: "",
                  multiple: "",
                  "collapse-tags": "",
                  "filter-method": _vm.filterMethod1,
                },
                on: { change: _vm.getCallRecord },
                model: {
                  value: _vm.customerIds,
                  callback: function ($$v) {
                    _vm.customerIds = $$v
                  },
                  expression: "customerIds",
                },
              },
              _vm._l(_vm.customerNamesList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
            _c("span", { staticClass: "span-lable" }, [_vm._v("联系人：")]),
            _c(
              "el-select",
              {
                staticStyle: { width: "300px" },
                attrs: {
                  placeholder: "请选择联系人",
                  size: "small",
                  filterable: "",
                  multiple: "",
                  "collapse-tags": "",
                  "filter-method": _vm.filterMethod,
                },
                on: { change: _vm.getCallRecord },
                model: {
                  value: _vm.contactIds,
                  callback: function ($$v) {
                    _vm.contactIds = $$v
                  },
                  expression: "contactIds",
                },
              },
              _vm._l(_vm.contactNamesList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("状态：")]),
            _vm._l(_vm.stateList, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "span-option",
                  class: item.value === _vm.status ? "is-select" : " ",
                  on: {
                    click: function ($event) {
                      return _vm.clickState(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "div-table" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { color: "#333" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "callOutName",
                  label: "客户名称",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.callOutName || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "contactName",
                  label: "联系人",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.contactName || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customerNumber",
                  label: "手机号码",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ownerName",
                  label: "归属人",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "callTime",
                  label: "拨打时间",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "拨打状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "play-status",
                          {
                            attrs: {
                              type: scope.row.status == 3 ? "success" : "error",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.status == 3 ? "已接通" : "未接通"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "bridgeDurationFormat", label: "通话时长" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 3
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickOpen(scope.row)
                                  },
                                },
                              },
                              [_vm._v("语音聊天")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            staticStyle: { "margin-top": "60px" },
            attrs: {
              "page-num": _vm.pageNum,
              "page-size": _vm.pageSize,
              total: _vm.total,
            },
            on: {
              sizeChange: _vm.handleSizeChange,
              currentChange: _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "audio-dialog",
          attrs: {
            title: "聊天录音",
            visible: _vm.dialogVisible,
            width: "720px",
            "before-close": _vm.handleCloseDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticClass: "audio-wrap" },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("客户名称："),
                  _c("span", { staticClass: "darkText" }, [
                    _vm._v(_vm._s(_vm.currentRecord.callOutName || "--")),
                  ]),
                ]),
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("手机号码："),
                  _c("span", { staticClass: "darkText" }, [
                    _vm._v(_vm._s(_vm.currentRecord.customerNumber || "--")),
                  ]),
                ]),
                _c(
                  "p",
                  { staticClass: "grayText" },
                  [
                    _vm._v("拨打状态： "),
                    _vm.currentRecord.status == 3
                      ? _c("play-status", { attrs: { type: "success" } }, [
                          _vm._v("已接通"),
                        ])
                      : _c("play-status", { attrs: { type: "error" } }, [
                          _vm._v("未接通"),
                        ]),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("联系人："),
                  _c("span", { staticClass: "darkText" }, [
                    _vm._v(_vm._s(_vm.currentRecord.contactName || "--")),
                  ]),
                ]),
                _c(
                  "p",
                  { staticClass: "grayText flex" },
                  [
                    _vm._v("归属人： "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.currentRecord.ownerName,
                          placement: "top-end",
                        },
                      },
                      [
                        _c("span", { staticClass: "darkText ellipsis" }, [
                          _vm._v(_vm._s(_vm.currentRecord.ownerName || "--")),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "grayText" }, [
                  _vm._v("通话时长："),
                  _c("span", { staticStyle: { color: "#374FB8" } }, [
                    _vm._v(_vm._s(_vm.currentRecord.bridgeDurationFormat)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c("audioPlay", {
            key: _vm.currentRecord.requestUniqueId,
            ref: "audioPlay",
            attrs: { uniqueId: _vm.currentRecord.requestUniqueId },
          }),
        ],
        1
      ),
      _c("detail", { ref: "detail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }